import { render, staticRenderFns } from "./Fittings.vue?vue&type=template&id=18fcc987&"
import script from "./Fittings.vue?vue&type=script&lang=js&"
export * from "./Fittings.vue?vue&type=script&lang=js&"
import style0 from "./Fittings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports